module.exports = __webpack_public_path__ + "static/Raleway-Regular-88f197a947979b50383211158d614081.woff2";